import { fetcher } from "helpers/fetcher";

import { TUpdateUserAccessRightReq, TUpdateUserAccessRightRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateUserAccessRight = async (
  payload?: TUpdateUserAccessRightReq
) => {
  return await fetcher<
    TUpdateUserAccessRightRes,
    TUpdateUserAccessRightReq["data"]
  >(ENDPOINT.MANAGEMENT.UPDATE_USER_ACCESS_RIGHT, {
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.MANAGEMENT.UPDATE_USER_ACCESS_RIGHT.version,
      [API_HEADER.BU_ID]: payload?.idBu,
    },
    data: payload?.data,
  });
};

export const mutationUpdateUserAccessRight = async (
  payload?: TUpdateUserAccessRightReq
) => {
  return (await updateUserAccessRight(payload)).data;
};

mutationUpdateUserAccessRight._key = (payload?: TUpdateUserAccessRightReq) => [
  ENDPOINT.MANAGEMENT.UPDATE_USER_ACCESS_RIGHT.url,
  payload,
];
